import axios from 'axios';
import authService from './authService';

// Simple subscribers so components can react (e.g. show a toast if needed later)
const logoutListeners = new Set();
export function onAutoLogout(cb){ logoutListeners.add(cb); return () => logoutListeners.delete(cb); }

let navigating = false;
function triggerLogout(reason){
  if(navigating) return;
  navigating = true;
  authService.logout();
  logoutListeners.forEach(l => { try { l(reason); } catch(_){} });
  // Hard redirect to ensure all state cleared (Router re-mounts)
  if(window.location.pathname !== '/login') {
    window.location.replace('/login');
  } else {
    navigating = false; // already on login
  }
}

// Response interceptor: if 401 or 403 -> logout
axios.interceptors.response.use(
  res => res,
  err => {
    const status = err?.response?.status;
    if(status && [401,403].includes(status)) {
      triggerLogout('http-unauthorized');
    } else {
      // Sometimes backend might respond 401 with a different shape or a cached layer returns 200 but body indicates invalid – defensively inspect message
      const msg = err?.response?.data?.msg || err?.response?.data?.message;
      if(msg && /token is not valid/i.test(msg)) {
        triggerLogout('invalid-token-msg');
      }
    }
    return Promise.reject(err);
  }
);

// Proactive token expiry check every 30s
let expiryTimer = null;
function immediateExpiryCheck(){
  const user = authService.getCurrentUser();
  const token = user?.token;
  if(!token) return;
  const decoded = authService.decodeJwt(token);
  const exp = decoded?.exp;
  if(exp){
    const nowSec = Math.floor(Date.now()/1000);
    if(nowSec >= exp){
      triggerLogout('token-expired-immediate');
    }
  }
}

function scheduleExpiryCheck(){
  if(expiryTimer) return;
  expiryTimer = setInterval(() => {
    const user = authService.getCurrentUser();
    const token = user?.token;
    if(!token){ return; }
    const decoded = authService.decodeJwt(token);
    const exp = decoded?.exp; // seconds epoch
    if(!exp) return; // no exp -> skip
    const nowSec = Math.floor(Date.now()/1000);
    if(nowSec >= exp){
      triggerLogout('token-expired');
    }
  }, 30000);
}
immediateExpiryCheck();
scheduleExpiryCheck();

// Export noop to allow importing just for side effects
export default function setupAuthGuards(){ /* already executed */ }